var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11183 0.97505C5.05974 0.00831676 3.44259 0.00831676 2.3905 0.97505C2.34741 1.01464 2.30142 1.06065 2.24169 1.12039L1.34419 2.01788C0.441081 2.921 0.0619618 4.22292 0.339024 5.4697C1.91099 12.5436 7.43553 18.0681 14.5094 19.6401C15.7562 19.9171 17.0581 19.538 17.9612 18.6349L18.8586 17.7375C18.9184 17.6777 18.9644 17.6317 19.004 17.5886C19.9708 16.5365 19.9708 14.9193 19.004 13.8673C18.9644 13.8241 18.9184 13.7781 18.8586 13.7184L17.3894 12.2491C16.3693 11.229 14.8287 10.9372 13.5063 11.5137C12.7492 11.8437 11.8672 11.6767 11.2832 11.0927L8.88639 8.69589C8.30239 8.11188 8.13536 7.22994 8.46538 6.47283C9.04184 5.15037 8.75009 3.60984 7.72999 2.58974L6.26066 1.12041C6.20093 1.06066 6.15492 1.01464 6.11183 0.97505Z",
    fill: "#004CBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.089bdecdec60dfd7b819ad4a4cdd773f.svg";
export { ForwardRef as ReactComponent };